import React from "react";
import { MoreVertical } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import { Button } from "../ui/button";
import { cn } from "../../lib/utils";

export default function MessageActions({
  onDeleteForMe,
  onDeleteForAll,
  disabled,
}) {
  const hasActions = onDeleteForMe || onDeleteForAll;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className={cn(
            "h-7 w-7 shrink-0 opacity-70 hover:opacity-100",
            disabled && "pointer-events-none opacity-40",
          )}
          disabled={disabled || !hasActions}
        >
          <MoreVertical className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[160px]">
        {onDeleteForMe && (
          <DropdownMenuItem onClick={onDeleteForMe}>
            Delete for me
          </DropdownMenuItem>
        )}
        {onDeleteForAll && (
          <DropdownMenuItem
            onClick={onDeleteForAll}
            className="text-destructive focus:text-destructive"
          >
            Delete for all
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
